import React from "react";

import Aos from "aos";
import { useEffect } from "react";

export const Aboutus = (props) => {
  useEffect(() => {
    Aos.init({ duration: 600 });
  }, []);
  return (
    <div id="features" className="  overflow-hidden ">
      <div className="">
        <div className="flex flex-col xs:px-[20px] sm:mt-20 md:mt-0 md:px-[100px]   items-center justify-center">
          <div className="md:grid md:grid-cols-2 items-center gap-5 ">
            <div data-aos="fade-right" data-aos-delay="100 pt-5">
              <h1 className="text-[#002e5b] py-4 ">About Us</h1>
              <p className="py-2 text-[15px]">
                Matrix Resources Limited is a company incorported under the
                company act (cap. 486). We offer a diverse array of solutions to
                our clients. With several years of experience in delivering
                exceptional customer satisfaction, the company has established a
                strong presence not only in Kenya but also across East Africa,
                South Sudan, Sub-Saharan Africa, Europe, Dubai, and Japan.
                Matrix Resources Limited takes pride in its wide range of
                products and services, which are characterized by high quality
                and timely delivery.
              </p>
              <p className="py-2 text-[15px]">
                We are dealers in general supplies, healthcare equpment
                supplies, petroleum product sales, interior design, Electrical,
                Electronics, IT solutions, household goods and stationaries. As
                a testament to their commitment to excellence, the company has
                been steadily growing and expanding its business
                internationally, receiving positive feedback from satisfied
                clients.
              </p>
              <div className="py-2">
                <button>
                  {/* <h2 className="text-[#002e5b] underline uppercase font-[700]">
                    Take a Tour
                  </h2> */}
                </button>
              </div>
            </div>

            <div
              data-aos="fade-left"
              data-aos-delay="100"
              className=" relative sm:pt-4 md:pt-0 ml-auto md:w-[500px] px-4 justify-center rounded-lg  items-center flex flex-col"
            >
              <div>
                <div className="xs:h-[50vh] md:h-[100vh] xs:w-[180px] md:w-[200px] bg-[#ffe100]"></div>
              </div>
              <div className="absolute md:mt-0 sm:mt-20 flex justify-center items-center ">
                <img src="/images/whoweare.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div
          className="bg-[#e4e3e3]  "
          data-aos="fade-top"
          data-aos-delay="150"
        >
          <div className="xs:px-[20px] md:px-[100px] md:pt-0 xs:pt-10 py-10 grid md:grid-cols-2 ">
            <div className="xs:hidden md:block">
              <img src="/images/whowearetwo.png" alt="" />
            </div>
            <div>
              <div className=" xs:px-[0px] md:px-[45px]">
                <div>
                  <h1 className="text-[#002e5b] py-4">Our Vision</h1>
                  <p className="text-[15px]">
                    To grow and achieve market leadership by exeeding customers
                    experience in all our business activities
                  </p>
                </div>
                <div>
                  <h1 className="text-[#002e5b] py-4 ">Our Values</h1>
                  <p className="text-[15px]">
                    Customer above everthing else Our People our assets Qaulity
                    and commitment to excellence Teamwork and coporation
                    Unquestionable Integrity
                  </p>
                </div>

                <div className="xs:pt-4 md:pt-32 flex mt-auto">
                  <button>
                    {/* <h2 className="text-[#002e5b] underline uppercase font-[700]">
                      Take a Tour
                    </h2> */}
                  </button>
                </div>
              </div>
            </div>
            <div className="xs:pt-4 md:pt-0 xs:block md:hidden flex items-center w-full">
              <div className="flex justify-center items-center w-full">
                <img src="/images/whowearetwo.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
